import { render } from "./categoryAdvertisingEvent.vue?vue&type=template&id=7f7bfcac"
import script from "./categoryAdvertisingEvent.vue?vue&type=script&lang=js"
export * from "./categoryAdvertisingEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__